module.exports = __webpack_public_path__ + "Flag-554.ef0ecd13851d342fa7603bfe52d33688.svg";